import React, { useState, useCallback } from 'react'
import { TabContract } from './TabContract'
import { TabExecution } from './TabExecution'
import { TabPlan } from './TabPlan'
import { TabZakupki } from './TabZakupki'

enum Tabs {
    PLAN = 'План закупки',
    ZAKUPKI = 'Закупки',
    CONTRACT = 'Договор',
    EXECUTION = 'Исполнение',
}

export const OfferModules: React.FC = () => {
    const [activeTab, setActiveTab] = useState(Tabs.PLAN)

    const renderContent = useCallback((tab: Tabs) => {
        switch (tab) {
            case Tabs.ZAKUPKI:
                return <TabZakupki />
            case Tabs.CONTRACT:
                return <TabContract />
            case Tabs.EXECUTION:
                return <TabExecution />
            default:
                return <TabPlan />
        }
    }, [])

    return (
        <>
            <h1 className="mt-10 font-bold text-white text-2xl">
                Модули управления закупками
            </h1>
            <ul className="flex flex-col md:flex-row gap-4 text-white">
                {Object.entries(Tabs).map(([key, value]) => (
                    <li
                        key={key}
                        className={
                            'tab_item ' +
                            (activeTab == value
                                ? 'bg-[#407bff]'
                                : 'bg-[#262427]')
                        }
                        onClick={() => setActiveTab(value)}
                    >
                        {value}
                    </li>
                ))}
            </ul>
            <div>{renderContent(activeTab)}</div>
        </>
    )
}
